import React from "react";
import { useNavigate } from "react-router-dom";

export const AssessmentStartup = () => {
    const navigate = useNavigate();

    return (
        <div className="immployer__assessment_startup">
            <h2 className="color_dark">Employer Assessment</h2>
            <br />
            <p>
                In just a few minutes, you will discover the best immigration pathway to hire or retain global talent for your role.
                Plus, you will gain access to trusted, reliable partners to guide you every step of the way!
            </p>
            <br />
            <p className="wt_500 color_dark">Step 1</p>
            <p>Answer a few questions about the role you're looking to fill.</p>
            <br />
            <p className="wt_500 color_dark">Step 2</p>
            <p>Review recommendations on best immigration pathways, this includes costs and timelines!</p>
            <br />
            <p className="wt_500 color_dark">Step 3</p>
            <p>Connect with trusted partners who will help you through every step of the process. </p>
            <br />
            <button
                className="immployer__btn immployer__btn__primary"
                onClick={() => navigate('/assessments/new')}
            >
                Start Assessment
            </button>
        </div>
    );
};